<h1>{{ 'services_backend_configuration' | myLbTranslate }}</h1>
<form [formGroup]="serviceForm" [loaded]="!wizardService.isLoading" [class.full-width]="isFormFullWidth">
    <div [formGroupName]="subStepEnum.GENERAL" [hidden]="getWizardSubStepState(subStepEnum.GENERAL)">
        <h2>{{ subStepEnum.GENERAL | myLbTranslate }}</h2>
        <section data-control-name="name">
            <div *ngIf="!isInputHidden('name')" class="form-group">
                <label for="pool-name{{templateIndex}}">{{ 'name' | myLbTranslate }}*</label>
                <div class="form-content">
                    <ng-container *ngIf="namePrefix">
                        <span class="name-prefix">{{ namePrefix }}</span>
                    </ng-container>
                    <input
                        id="pool-name{{templateIndex}}"
                        formControlName="name"
                        name="name"
                        title="name"
                        type="text">
                    <app-validation-messages [control]="serviceForm.get(subStepEnum.GENERAL + '.name')">
                    </app-validation-messages>
                    <app-help class="help-button" tag="pools_name"></app-help>
                </div>
            </div>
        </section>
    </div>
    <!-- Realservers -->
    <div [formGroupName]="subStepEnum.RIP_IDS" [hidden]="getWizardSubStepState(subStepEnum.RIP_IDS)">
        <section data-control-name="ripIds">
            <div *ngIf="!isInputHidden('ripIds')" class="embedded">
                <app-real-server-table
                    templateType="gslb"
                    [templateIndex]="templateIndex"
                    [ripIds]="serviceForm.get(subStepEnum.RIP_IDS + '.ripIds').value"
                    (ripIdsOut)="setRipIds($event)">
                </app-real-server-table>
            </div>
        </section>
    </div>
</form>
